import React from "react";
import { Modal, Form, Select, Input } from "antd";
const { TextArea } = Input;

const CounterPartyModal = ({
  visible,
  onOk,
  onCancel,
  form,
  handleEmailChange,
}) => (
  <Modal
    title="Send Contract to Counter Party"
    open={visible}
    onOk={() => onOk("Counter Party")}
    onCancel={onCancel}
    okText="Send"
    okButtonProps={{
      style: {
        backgroundColor: "#4E36A3",
        color: "white",
        height: "40px",
        width: "100px",
      },
    }}
    cancelButtonProps={{
      style: {
        color: "#4E36A3",
        height: "40px",
        width: "100px",
      },
    }}
  >
    <Form form={form}>
      <h1 className="font-lg">Receiver's Email</h1>
      <Form.Item name="receiver">
        <Select
          mode="tags"
          style={{ width: "100%" }}
          placeholder="Enter receiver's email"
          onChange={handleEmailChange}
          required
        />
      </Form.Item>

      <h1 className="font-lg">Remark</h1>
      <Form.Item name="remark" className="pt-1">
        <TextArea required />
      </Form.Item>
    </Form>
  </Modal>
);

export default CounterPartyModal;
